import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';

import SectionHeader from '../SectionHeader';

export default class TestimonialSection extends React.Component {
  cardWithImage(testimonial, key) {
    return (
      <div key={key} className="column">
        <div className="ui segment">
          <h4 className="primary-text-color">{testimonial.text}</h4>
        </div>
        <div className="ui grid middle aligned">
          <div className="five wide computer four wide mobile column">
            <img className="ui image tiny" src={require(`../../assets/${testimonial.image}`)} />
          </div>
          <div className="eleven wide column no-p-l">
            <p className="thick-text no-bottom">{testimonial.name}</p>
            <p className="italic-text">{testimonial.company}</p>
          </div>
        </div>
      </div>
    );
  }

  cardNoImage(testimonial, key) {
    return (
      <div key={key} className="column">
        <div className="ui segment">
          <h4>{testimonial.text}</h4>
          <p className="thick-text">{testimonial.name}</p>
          <p className="thick-text">{testimonial.company}</p>
        </div>
      </div>
    );
  }

  render() {
    const { titleText, testimonials, pageType, inverted } = this.props;

    return (
      <div className={classnames('background', pageType, { inverted })}>
        <div className="ui container p-b-4">

          <SectionHeader inverted={inverted} titleText={titleText} />

          <div className="ui grid stackable">
            <div className="three column row">
              {_.map(testimonials, (testimonial, index) => this.cardWithImage(testimonial, index))}
            </div>
          </div>
        </div>
        <div className="ui fitted divider" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/TestimonialSection/index.jsx